/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessModuleConfig } from './AccessModuleConfig';
import {
    AccessModuleConfigFromJSON,
    AccessModuleConfigFromJSONTyped,
    AccessModuleConfigToJSON,
} from './AccessModuleConfig';
import type { CdrVersionForMigration } from './CdrVersionForMigration';
import {
    CdrVersionForMigrationFromJSON,
    CdrVersionForMigrationFromJSONTyped,
    CdrVersionForMigrationToJSON,
} from './CdrVersionForMigration';
import type { ConfigResponseEchoUserGroups } from './ConfigResponseEchoUserGroups';
import {
    ConfigResponseEchoUserGroupsFromJSON,
    ConfigResponseEchoUserGroupsFromJSONTyped,
    ConfigResponseEchoUserGroupsToJSON,
} from './ConfigResponseEchoUserGroups';

/**
 * 
 * @export
 * @interface ConfigResponse
 */
export interface ConfigResponse {
    /**
     * G-Suite domain containing user accounts.
     * @type {string}
     * @memberof ConfigResponse
     */
    gsuiteDomain: string;
    /**
     * The GCP project environment in which this All of Us app is running.
     * @type {string}
     * @memberof ConfigResponse
     */
    projectId?: string;
    /**
     * The Firecloud URL to use for REST requests.
     * @type {string}
     * @memberof ConfigResponse
     */
    firecloudURL?: string;
    /**
     * Stackdriver API key for error reporting, scoped to a particular
     * domain. If unset, Stackdriver error reporting should be disabled.
     * @type {string}
     * @memberof ConfigResponse
     */
    publicApiKeyForErrorReports?: string;
    /**
     * Whether the Compliance Training access module is enabled.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableComplianceTraining?: boolean;
    /**
     * The SAML identity provider ID for Absorb.
     * @type {string}
     * @memberof ConfigResponse
     */
    absorbSamlIdentityProviderId?: string;
    /**
     * The SAML service provider ID for Absorb.
     * @type {string}
     * @memberof ConfigResponse
     */
    absorbSamlServiceProviderId?: string;
    /**
     * Whether a user is allowed to self-bypass. Only enabled in test environments.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    unsafeAllowSelfBypass?: boolean;
    /**
     * The default dollar amount of initial credits allotted to each user
     * @type {number}
     * @memberof ConfigResponse
     */
    defaultInitialCreditsDollarLimit?: number;
    /**
     * Whether to show the Event Date modifier in cohort builder
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableEventDateModifier?: boolean;
    /**
     * Whether users are given the option to link their RAS/ID.me account to AoU
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableRasIdMeLinking?: boolean;
    /**
     * Whether users are given the option to link their RAS/Login.gov account to AoU
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableRasLoginGovLinking?: boolean;
    /**
     * The RAS base host name.
     * @type {string}
     * @memberof ConfigResponse
     */
    rasHost?: string;
    /**
     * the point when we give users the option to update the affirmations needed to use the system.
     * @type {number}
     * @memberof ConfigResponse
     */
    accessRenewalLookback?: number;
    /**
     * the point when we give users the option to update their compliance items that involve training.
     * @type {number}
     * @memberof ConfigResponse
     */
    complianceTrainingRenewalLookback?: number;
    /**
     * The RAS OAuth client id.
     * @type {string}
     * @memberof ConfigResponse
     */
    rasClientId?: string;
    /**
     * The URL that can sign out RAS login session.
     * @type {string}
     * @memberof ConfigResponse
     */
    rasLogoutUrl?: string;
    /**
     * The initial credits billing account id
     * @type {string}
     * @memberof ConfigResponse
     */
    initialCreditsBillingAccountId?: string;
    /**
     * 
     * @type {Array<AccessModuleConfig>}
     * @memberof ConfigResponse
     */
    accessModules?: Array<AccessModuleConfig>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConfigResponse
     */
    currentDuccVersions?: Array<number>;
    /**
     * The newest DUCC version users should sign.
     * @type {number}
     * @memberof ConfigResponse
     */
    latestDuccVersion?: number;
    /**
     * Whether a captcha check is part of the new user registration process
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableCaptcha?: boolean;
    /**
     * Whether to enable visual data explorer.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableDataExplorer?: boolean;
    /**
     * The tanagra base url
     * @type {string}
     * @memberof ConfigResponse
     */
    tanagraBaseUrl?: string;
    /**
     * Whether users are allowed to pause GKE applications.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableGKEAppPausing?: boolean;
    /**
     * Whether users are allowed to choose machine type when creating GKE applications.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableGKEAppMachineTypeChoice?: boolean;
    /**
     * If true, show banner notifying users of login issue
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableLoginIssueBanner?: boolean;
    /**
     * If true, allow for user's initial credits to expire.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableInitialCreditsExpiration?: boolean;
    /**
     * If true, allow unlinking billing accounts when initial credits are expired or used up.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableUnlinkBillingForInitialCredits?: boolean;
    /**
     * The number of days that a user's initial credits are valid for.
     * @type {number}
     * @memberof ConfigResponse
     */
    initialCreditsValidityPeriodDays?: number;
    /**
     * The number of days that a user's initial credits can be extended for.
     * @type {number}
     * @memberof ConfigResponse
     */
    initialCreditsExtensionPeriodDays?: number;
    /**
     * The number of days before a user's initial credits expire that they will receive a warning.
     * @type {number}
     * @memberof ConfigResponse
     */
    initialCreditsExpirationWarningDays?: number;
    /**
     * The number of days before a user's initial credits expire that they will receive a warning.
     * @type {Array<number>}
     * @memberof ConfigResponse
     */
    initialCreditsExpirationWarningDaysList?: Array<number>;
    /**
     * Whether users are prevented from accessing the Compliance Training
     * @type {boolean}
     * @memberof ConfigResponse
     */
    blockComplianceTraining?: boolean;
    /**
     * If true, the api is down for maintenance and will block all requests.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    isDownForMaintenance?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConfigResponse
     */
    gceVmZones?: Array<string>;
    /**
     * The zone that is selected by default when creating a GCE VM. This must be one of the values specified in gceVmZones.
     * @type {string}
     * @memberof ConfigResponse
     */
    defaultGceVmZone?: string;
    /**
     * If true, enable the creating workspaces in Verily Workbench
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableVWBWorkspaceCreation?: boolean;
    /**
     * If true, will display the VWB banner on RW homepage
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableVWBHomepageBanner?: boolean;
    /**
     * If true, will display the CTPlus card
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableCTPlusCards?: boolean;
    /**
     * If true, will display the "Migrate to Verily Workbench" button on workspace pages.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableVwbMigration?: boolean;
    /**
     * If true, will display the archived workspace recovery flow and recovery UI on workspace pages.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    enableWorkspaceArchiveRecovery?: boolean;
    /**
     * If true, blocks access to all RW1.0 functionality for standard users. Only archive recovery functionality remains available.
     * @type {boolean}
     * @memberof ConfigResponse
     */
    restrictLegacyAccess?: boolean;
    /**
     * 
     * @type {Array<CdrVersionForMigration>}
     * @memberof ConfigResponse
     */
    cdrVersionsForMigration?: Array<CdrVersionForMigration>;
    /**
     * 
     * @type {ConfigResponseEchoUserGroups}
     * @memberof ConfigResponse
     */
    echoUserGroups?: ConfigResponseEchoUserGroups;
}

/**
 * Check if a given object implements the ConfigResponse interface.
 */
export function instanceOfConfigResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "gsuiteDomain" in value;

    return isInstance;
}

export function ConfigResponseFromJSON(json: any): ConfigResponse {
    return ConfigResponseFromJSONTyped(json, false);
}

export function ConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gsuiteDomain': json['gsuiteDomain'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'firecloudURL': !exists(json, 'firecloudURL') ? undefined : json['firecloudURL'],
        'publicApiKeyForErrorReports': !exists(json, 'publicApiKeyForErrorReports') ? undefined : json['publicApiKeyForErrorReports'],
        'enableComplianceTraining': !exists(json, 'enableComplianceTraining') ? undefined : json['enableComplianceTraining'],
        'absorbSamlIdentityProviderId': !exists(json, 'absorbSamlIdentityProviderId') ? undefined : json['absorbSamlIdentityProviderId'],
        'absorbSamlServiceProviderId': !exists(json, 'absorbSamlServiceProviderId') ? undefined : json['absorbSamlServiceProviderId'],
        'unsafeAllowSelfBypass': !exists(json, 'unsafeAllowSelfBypass') ? undefined : json['unsafeAllowSelfBypass'],
        'defaultInitialCreditsDollarLimit': !exists(json, 'defaultInitialCreditsDollarLimit') ? undefined : json['defaultInitialCreditsDollarLimit'],
        'enableEventDateModifier': !exists(json, 'enableEventDateModifier') ? undefined : json['enableEventDateModifier'],
        'enableRasIdMeLinking': !exists(json, 'enableRasIdMeLinking') ? undefined : json['enableRasIdMeLinking'],
        'enableRasLoginGovLinking': !exists(json, 'enableRasLoginGovLinking') ? undefined : json['enableRasLoginGovLinking'],
        'rasHost': !exists(json, 'rasHost') ? undefined : json['rasHost'],
        'accessRenewalLookback': !exists(json, 'accessRenewalLookback') ? undefined : json['accessRenewalLookback'],
        'complianceTrainingRenewalLookback': !exists(json, 'complianceTrainingRenewalLookback') ? undefined : json['complianceTrainingRenewalLookback'],
        'rasClientId': !exists(json, 'rasClientId') ? undefined : json['rasClientId'],
        'rasLogoutUrl': !exists(json, 'rasLogoutUrl') ? undefined : json['rasLogoutUrl'],
        'initialCreditsBillingAccountId': !exists(json, 'initialCreditsBillingAccountId') ? undefined : json['initialCreditsBillingAccountId'],
        'accessModules': !exists(json, 'accessModules') ? undefined : ((json['accessModules'] as Array<any>).map(AccessModuleConfigFromJSON)),
        'currentDuccVersions': !exists(json, 'currentDuccVersions') ? undefined : json['currentDuccVersions'],
        'latestDuccVersion': !exists(json, 'latestDuccVersion') ? undefined : json['latestDuccVersion'],
        'enableCaptcha': !exists(json, 'enableCaptcha') ? undefined : json['enableCaptcha'],
        'enableDataExplorer': !exists(json, 'enableDataExplorer') ? undefined : json['enableDataExplorer'],
        'tanagraBaseUrl': !exists(json, 'tanagraBaseUrl') ? undefined : json['tanagraBaseUrl'],
        'enableGKEAppPausing': !exists(json, 'enableGKEAppPausing') ? undefined : json['enableGKEAppPausing'],
        'enableGKEAppMachineTypeChoice': !exists(json, 'enableGKEAppMachineTypeChoice') ? undefined : json['enableGKEAppMachineTypeChoice'],
        'enableLoginIssueBanner': !exists(json, 'enableLoginIssueBanner') ? undefined : json['enableLoginIssueBanner'],
        'enableInitialCreditsExpiration': !exists(json, 'enableInitialCreditsExpiration') ? undefined : json['enableInitialCreditsExpiration'],
        'enableUnlinkBillingForInitialCredits': !exists(json, 'enableUnlinkBillingForInitialCredits') ? undefined : json['enableUnlinkBillingForInitialCredits'],
        'initialCreditsValidityPeriodDays': !exists(json, 'initialCreditsValidityPeriodDays') ? undefined : json['initialCreditsValidityPeriodDays'],
        'initialCreditsExtensionPeriodDays': !exists(json, 'initialCreditsExtensionPeriodDays') ? undefined : json['initialCreditsExtensionPeriodDays'],
        'initialCreditsExpirationWarningDays': !exists(json, 'initialCreditsExpirationWarningDays') ? undefined : json['initialCreditsExpirationWarningDays'],
        'initialCreditsExpirationWarningDaysList': !exists(json, 'initialCreditsExpirationWarningDaysList') ? undefined : json['initialCreditsExpirationWarningDaysList'],
        'blockComplianceTraining': !exists(json, 'blockComplianceTraining') ? undefined : json['blockComplianceTraining'],
        'isDownForMaintenance': !exists(json, 'isDownForMaintenance') ? undefined : json['isDownForMaintenance'],
        'gceVmZones': !exists(json, 'gceVmZones') ? undefined : json['gceVmZones'],
        'defaultGceVmZone': !exists(json, 'defaultGceVmZone') ? undefined : json['defaultGceVmZone'],
        'enableVWBWorkspaceCreation': !exists(json, 'enableVWBWorkspaceCreation') ? undefined : json['enableVWBWorkspaceCreation'],
        'enableVWBHomepageBanner': !exists(json, 'enableVWBHomepageBanner') ? undefined : json['enableVWBHomepageBanner'],
        'enableCTPlusCards': !exists(json, 'enableCTPlusCards') ? undefined : json['enableCTPlusCards'],
        'enableVwbMigration': !exists(json, 'enableVwbMigration') ? undefined : json['enableVwbMigration'],
        'enableWorkspaceArchiveRecovery': !exists(json, 'enableWorkspaceArchiveRecovery') ? undefined : json['enableWorkspaceArchiveRecovery'],
        'restrictLegacyAccess': !exists(json, 'restrictLegacyAccess') ? undefined : json['restrictLegacyAccess'],
        'cdrVersionsForMigration': !exists(json, 'cdrVersionsForMigration') ? undefined : ((json['cdrVersionsForMigration'] as Array<any>).map(CdrVersionForMigrationFromJSON)),
        'echoUserGroups': !exists(json, 'echoUserGroups') ? undefined : ConfigResponseEchoUserGroupsFromJSON(json['echoUserGroups']),
    };
}

export function ConfigResponseToJSON(value?: ConfigResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gsuiteDomain': value.gsuiteDomain,
        'projectId': value.projectId,
        'firecloudURL': value.firecloudURL,
        'publicApiKeyForErrorReports': value.publicApiKeyForErrorReports,
        'enableComplianceTraining': value.enableComplianceTraining,
        'absorbSamlIdentityProviderId': value.absorbSamlIdentityProviderId,
        'absorbSamlServiceProviderId': value.absorbSamlServiceProviderId,
        'unsafeAllowSelfBypass': value.unsafeAllowSelfBypass,
        'defaultInitialCreditsDollarLimit': value.defaultInitialCreditsDollarLimit,
        'enableEventDateModifier': value.enableEventDateModifier,
        'enableRasIdMeLinking': value.enableRasIdMeLinking,
        'enableRasLoginGovLinking': value.enableRasLoginGovLinking,
        'rasHost': value.rasHost,
        'accessRenewalLookback': value.accessRenewalLookback,
        'complianceTrainingRenewalLookback': value.complianceTrainingRenewalLookback,
        'rasClientId': value.rasClientId,
        'rasLogoutUrl': value.rasLogoutUrl,
        'initialCreditsBillingAccountId': value.initialCreditsBillingAccountId,
        'accessModules': value.accessModules === undefined ? undefined : ((value.accessModules as Array<any>).map(AccessModuleConfigToJSON)),
        'currentDuccVersions': value.currentDuccVersions,
        'latestDuccVersion': value.latestDuccVersion,
        'enableCaptcha': value.enableCaptcha,
        'enableDataExplorer': value.enableDataExplorer,
        'tanagraBaseUrl': value.tanagraBaseUrl,
        'enableGKEAppPausing': value.enableGKEAppPausing,
        'enableGKEAppMachineTypeChoice': value.enableGKEAppMachineTypeChoice,
        'enableLoginIssueBanner': value.enableLoginIssueBanner,
        'enableInitialCreditsExpiration': value.enableInitialCreditsExpiration,
        'enableUnlinkBillingForInitialCredits': value.enableUnlinkBillingForInitialCredits,
        'initialCreditsValidityPeriodDays': value.initialCreditsValidityPeriodDays,
        'initialCreditsExtensionPeriodDays': value.initialCreditsExtensionPeriodDays,
        'initialCreditsExpirationWarningDays': value.initialCreditsExpirationWarningDays,
        'initialCreditsExpirationWarningDaysList': value.initialCreditsExpirationWarningDaysList,
        'blockComplianceTraining': value.blockComplianceTraining,
        'isDownForMaintenance': value.isDownForMaintenance,
        'gceVmZones': value.gceVmZones,
        'defaultGceVmZone': value.defaultGceVmZone,
        'enableVWBWorkspaceCreation': value.enableVWBWorkspaceCreation,
        'enableVWBHomepageBanner': value.enableVWBHomepageBanner,
        'enableCTPlusCards': value.enableCTPlusCards,
        'enableVwbMigration': value.enableVwbMigration,
        'enableWorkspaceArchiveRecovery': value.enableWorkspaceArchiveRecovery,
        'restrictLegacyAccess': value.restrictLegacyAccess,
        'cdrVersionsForMigration': value.cdrVersionsForMigration === undefined ? undefined : ((value.cdrVersionsForMigration as Array<any>).map(CdrVersionForMigrationToJSON)),
        'echoUserGroups': ConfigResponseEchoUserGroupsToJSON(value.echoUserGroups),
    };
}

